<template>
    <v-row id="time-frame-btn" class="pa-5 d-flex align-center justify-space-between">
      <v-col cols="auto">
        <h2 class="project-title">{{ title }}</h2>
      </v-col>
 
      <v-col class="text-right" cols="auto">
        <v-btn
          v-for="timeFrame in timeFrames"
          :key="timeFrame"
          :style="{'background-color': isActive(timeFrame) ? '#a5e3fd' : '', color: isActive(timeFrame) ? '#00B3FF' : '#000000' }"
          class="mx-2"
          rounded
          text
          @click="changeTimeFrame(timeFrame)"
        >
          {{ timeFrame }}
        </v-btn>
      </v-col>
    </v-row>
  </template>
 
  <script>
  export default {
    props: {
      title: String,
      timeFrames: Array,
      activeTimeFrame: String,
    },
    methods: {
      isActive(timeFrame) {
        return this.activeTimeFrame === timeFrame;
      },
      changeTimeFrame(timeFrame) {
        this.$emit('change-time-frame', timeFrame);
      },
    },
  };
  </script>